import { Box, Button, FormHelperText, Stack, Typography } from "@mui/material";

import { SettingsWrapper } from "../SettingsWrapper";
import { useBillingHistoryFacade } from "../../hooks/useBillingHistoryFacade";
import { Table } from "../../../../components";
import { FONT_COLORS } from "../../../../constants";
import { billingHistoryColumns } from "../../lib/billingHistoryColumns";

export const BillingHistory = () => {
  const {
    isLoading,
    rows,
    error,
    loadMore,
    hasMore,
    total,
    redirectToInvoice,
  } = useBillingHistoryFacade();

  return (
    <SettingsWrapper
      heading="Billing History"
      subHeading="Summary on the payment history of your subscription plans"
    >
      <Table
        hideFooter
        disablePositionColumn
        columns={billingHistoryColumns}
        rows={rows}
        loading={isLoading}
        onRowClick={redirectToInvoice}
        rowHeight={50}
        sx={{ maxHeight: 258, minHeight: 106 }}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        height={32}
      >
        {!isLoading && error ? (
          <FormHelperText error>Failed to show billing history</FormHelperText>
        ) : (
          <>
            {hasMore ? (
              <Button onClick={loadMore} disabled={isLoading} sx={{ px: 0 }}>
                Load More
              </Button>
            ) : (
              <Box />
            )}
            <Typography
              fontSize={12}
              fontWeight={500}
              color={FONT_COLORS.subheading}
            >
              Records: {total}
            </Typography>
          </>
        )}
      </Stack>
    </SettingsWrapper>
  );
};
